const INITIAL_STATE = {
  errors: {},
  kanbanList: {},
  addPWSInstall: {},
  updatePWSInstall: {}
}

const kanban = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_KANBAN_LIST':
    return { ...state, ...INITIAL_STATE, kanbanList: action.data }
  case 'GET_KANBAN_LIST_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'ADD_PWS_INSTALL':
    return { ...state, ...INITIAL_STATE, addPWSInstall: action.data }
  case 'ADD_PWS_INSTALL_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'UPDATE_PWS_INSTALL':
    return { ...state, ...INITIAL_STATE, updatePWSInstall: action.data }
  case 'UPDATE_PWS_INSTALL_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default kanban;
